import { useGetNewOrdersCountQuery } from '@api/productRequest.api';

type ProductOrdeCount = {
  count?: number;
  isLoading: boolean;
  isError?: boolean;
};

type ProductOrdeCountOptionsProps = {
  skip?: boolean;
};

export const useProductOrderCount = (options: ProductOrdeCountOptionsProps): ProductOrdeCount => {
  const { skip } = options || {};
  const { data, isLoading, isError } = useGetNewOrdersCountQuery(undefined, {
    skip: skip,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    pollingInterval: 60 * 1000 * 5,
  });

  return {
    count: data,
    isLoading,
    isError,
  };
};
